<template>
    <div class="Server">
        <menuBox :step="2"></menuBox>
        <div class="title-box">Core business</div>

        <div class="serve-box">
            <div class="title">Our Comprehensive <br> Services Portfolio</div>
            <img src="../assets/home_2.png" class="sbtitle">
            <div class="serve-list">
                <div class="serve-item">
                    <img src="../assets/bus-1.png" class="bus">
                    <div>SEO Optimization</div>
                    <p> Elevate your website's search engine ranking, attract targeted audiences, and ensure sustainable traffic growth.</p>
                    <img src="../assets/bus-5.png" class="icon">
                </div>
                <div class="serve-item">
                    <img src="../assets/bus-2.png" class="bus">
                    <div>Advertising Promotion</div>
                    <p>Showcase your brand, products, or services globally to potential customers, enhancing brand exposure and driving sales growth.</p>
                    <img src="../assets/bus-5.png" class="icon">
                </div>
                <div class="serve-item">
                    <img src="../assets/bus-3.png" class="bus">
                    <div>Content Marketing</div>
                    <p>Deliver valuable content to attract and retain customers, fostering long-term, robust brand relationships.</p>
                    <img src="../assets/bus-5.png" class="icon">
                </div>
            </div>
        </div>

        <div class="digital-box">
            <div class="title">Unlocking Your Digital Potential: <br> Our Specialized Offerings</div>
            <img src="../assets/home_2.png" class="sbtitle">
            <div class="digital-us">
                <div class="digital-text">
                    <div class="digital-text-box">
                        <div class="number">01</div>
                        <div class="text-box">
                            <div>Specialized Website Design</div>
                            <p>-Craft visually stunning and user-friendly websites tailored to your brand identity and customer needs.</p>
                        </div>
                    </div>
                    <div class="digital-text-box">
                        <div class="number">01</div>
                        <div class="text-box">
                            <div>E-commerce Solutions</div>
                            <p>-Build robust e-commerce platforms that drive sales and streamline online transactions for your business.</p>
                        </div>
                    </div>
                    <div class="digital-text-box">
                        <div class="number">01</div>
                        <div class="text-box">
                            <div>Mobile App Development</div>
                            <p>-Create innovative and user-centric mobile applications to expand your reach and enhance customer engagement.</p>
                        </div>
                    </div>
                </div>
                <img src="../assets/bus-4.png" alt="">
            </div>
        </div>

        <div class="online-box">
            <div class="title">Greatening Your Online Presence</div>
            <img src="../assets/home_2.png" class="sbtitle">
            <div class="online-list">
                <div class="online-item">
                    <img src="../assets/bus-6.png" alt="">
                    <div class="bus-box">
                        Keyword Optimization
                        <img src="../assets/bus-10.png" alt="">
                    </div>
                </div>
                <div class="online-item">
                    <img src="../assets/bus-7.png" alt="">
                    <div class="bus-box">
                        Website Structure Enhancement
                        <img src="../assets/bus-10.png" alt="">
                    </div>
                </div>
                <div class="online-item">
                    <img src="../assets/bus-8.png" alt="">
                    <div class="bus-box">
                        Content Optimization and Creation
                        <img src="../assets/bus-10.png" alt="">
                    </div>
                </div>
                <div class="online-item">
                    <img src="../assets/bus-9.png" alt="">
                    <div class="bus-box">
                        Local SEO Optimization
                        <img src="../assets/bus-10.png" alt="">
                    </div>
                </div>
            </div>
        </div>

        <footerBox :step="2"></footerBox>
    </div>
</template>

<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: 'Server',
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
        }
    },
    mounted() {

    },
    methods: {
        aboutUs() {
            this.$router.push({ path: "aboutUs" });
        }
    }
}
</script>

<style lang="less" scoped>
.title {
    font-weight: 600;
    font-size: 58px;
    color: #333333;
}

.sbtitle {
    width: 305px;
    margin: auto;
    margin-top: 20px;
}


.title-box {
    height: 512px;
    background-image: url(../assets/title-box.png);
    background-size: 100% 100%;
    font-weight: 500;
    font-size: 75px;
    color: #040F1C;
    display: flex;
    align-items: center;
    justify-content: center;
}

.serve-box {
    padding: 120px 360px;
    text-align: center;

    .serve-list {
        text-align: left;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
    }

    .serve-item {
        width: 400px;
        margin-top: 80px;

        .bus {
            width: 110px;
        }

        .icon {
            width: 40px;
            margin-top: 40px;
        }

        div {
            font-weight: 500;
            font-size: 34px;
            color: #333333;
            margin-top: 40px;
        }

        p {
            font-weight: 400;
            font-size: 26px;
            color: rgba(51, 51, 51, 0.8);
            margin-top: 18px;
        }
    }
}

.digital-box {
    padding: 130px 360px;
    text-align: center;

    .digital-us {
        margin-top: 123px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
            width: 565px;
        }

        .digital-text {
            width: 500px;

            .digital-text-box {
                display: flex;
                align-items: flex-start;
                margin-bottom: 50px;
                text-align: left;

                .number {
                    color: #59BA41;
                    font-size: 67px;
                    font-weight: bold;
                }

                .text-box {
                    margin-left: 20px;

                    div {
                        font-weight: 500;
                        font-size: 24px;
                        color: #333333;
                    }

                    p {
                        font-weight: 400;
                        font-size: 20px;
                        color: #999999;
                        margin-top: 10px;
                    }
                }
            }
        }
    }
}

.online-box {
    padding: 120px 360px;
    text-align: center;

    .online-list {
        margin-top: 70px;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        text-align: left;

        .online-item {
            width: 300px;

            img {
                width: 300px;
            }

            .bus-box {
                font-weight: 400;
                font-size: 18px;
                color: rgba(51, 51, 51, 0.8);
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 20px;

                img {
                    width: 46px;
                }
            }
        }
    }
}
</style>
